import styled from 'styled-components'

import { media, transition } from '../../../../../../utils/style-utils'
import Btn from '../../../../../Btn'

const PlayButton = styled(Btn)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;

  ${transition('transform', 0.3)}

  ${media.touch`
    width: 100%;
    height: 100%;
    opacity: 0;
    transform: none;
  `}
`

export default PlayButton
